import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { get, post, del } from '../api/client.js';

export function useInvites() {
  return useQuery({
    queryKey: ['admin', 'invites'],
    queryFn: async () => (await get('/api/admin/crew/invites')).invites || [],
    staleTime: 30_000,
  });
}

export function useCreateInvite() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body) => post('/api/admin/crew/invites', body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['admin', 'invites'] }),
  });
}

export function useRevokeInvite() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (token) => del(`/api/admin/crew/invites/${token}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['admin', 'invites'] }),
  });
}
